import React from 'react';
import {useListContext} from 'react-admin';
import {useFormContext} from 'react-hook-form';

import {Button} from '../../../../components';

export const ClearFiltersButton = () => {
    const {displayedFilters, setFilters} = useListContext();
    const {setValue} = useFormContext();

    const onClearFilters = () => {
        setValue('brands', null);
        setValue('businessModels', null);
        setValue('channels', null);
        setValue('countries', null);
        setValue('isAvailableForNewProject', null);
        setValue('q', '');
        setValue('languages', null);
        setValue('rateRange', null);
        setValue('subchannels', null);
        setValue('timesheetStatus', null);
        setValue('timezones', null);
        setValue('tools', null);
        setValue('verticals', null);
        setValue('workTypes', null);
        setValue('yearsOfExperience', null);

        setFilters({}, displayedFilters);
    };

    return (
        <Button
            className="secondary"
            color="primary"
            disableElevation
            variant="contained"
            onClick={onClearFilters}
        >
            Clear filters
        </Button>
    );
};